import Style from './SinglePage.module.less';
import StepBrick from '../StepBrick/StepBrick';
import InlineSVG from 'react-inlinesvg';
import LogoIcon from '../../assets/icon/logo.svg';
import FJLocalStore from '../../store/FJLocalStore';
import posterImg from '../../assets/img/poster5.6.png';
import useLocalStore from '../../hooks/useLocalStore';
import { useEffect } from 'react';
import FJUtil from '../../util/FJUtil';

const SinglePage = props => {
    useLocalStore();
    let { page } = props;

    useEffect(() => {
        FJUtil.ealog('sign up visit', {
            'page&panel': 'page',
            page: page,
        });
    }, []);

    return (
        <div className={Style.singlePage}>
            <div className={Style.singleLeft}>
                <div className={Style.singleLeft_content}>
                    <a className={Style.logo_box} href={FJLocalStore.getJumpUrl('/')}>
                        <InlineSVG src={LogoIcon} />
                    </a>
                    <span className={Style.great_meet}>{FJLocalStore._('great-to-meet')}</span>
                    <img
                        src={posterImg}
                        width={840}
                        height={482}
                        alt={'FlexClip - ' + FJLocalStore._('login-or-sign')}
                        loading='lazy'
                    />
                </div>
            </div>
            <div className={Style.singleRight}>
                <StepBrick />
            </div>
        </div>
    );
};
export default SinglePage;
